module.exports = __webpack_public_path__ + "img/qr_code_wxg.6aab6ad2.jpg";